module.exports = __webpack_public_path__ + "static/img/cqwjm.5bf60de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/cqwjm.png
// module id = bM1e
// module chunks = 1